import { FC } from 'react';
import { ActiveAlarm } from '../../pages/sensors-v2/types/sensors';
import { ALARM_LABEL, severityColor, timeAgo } from './severity';

type Props = { alarm: ActiveAlarm; showTime?: boolean };

export const AlarmTypeChip: FC<Props> = ({ alarm, showTime = true }) => {
  const c = severityColor(alarm.severity);
  return (
    <span
      style={{
        background: c.bg,
        color: c.text,
        padding: '2px 8px',
        borderRadius: '10px',
        fontSize: '11px',
        fontWeight: 500,
        marginRight: 4,
        whiteSpace: 'nowrap',
      }}
    >
      {ALARM_LABEL[alarm.type]}{showTime ? ` · ${timeAgo(alarm.since)}` : ''}
    </span>
  );
};
